import React from 'react';
import styles from './index.scss';
import { Form, InputGroup } from 'react-bootstrap';
import type { FormControlProps } from 'react-bootstrap';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

const PasswordInput = React.forwardRef(
  (props: FormControlProps, ref: React.Ref<HTMLInputElement>) => {
    const [visible, setVisible] = React.useState(false);

    return (
      <div>
        <InputGroup>
          <Form.Control
            className={cx(['input'])}
            autoComplete="new-password"
            {...props}
            ref={ref}
            type={visible ? 'text' : 'password'}
          />
          <InputGroup.Text
            onClick={() => setVisible(!visible)}
            className={cx([styles.eyeIcon])}>
            {visible ? (
              <i className="iconfont icon-ico-eye-show" />
            ) : (
              <i className="iconfont icon-ico-eye-hide" />
            )}
          </InputGroup.Text>
        </InputGroup>
      </div>
    );
  }
);

export default PasswordInput;
